import React from 'react';
import {Button, Card, Col, Form, Icon, Input, message, Modal, Popover, Row, Select, Spin, Tooltip, Upload} from "antd"
import {withRouter} from 'react-router-dom';
import {API, Auth, Storage} from "aws-amplify"
import {CustomSpinner} from "../../Components/Spin/CustomSpiner"
import {connect} from "react-redux"
import definitions from '../../Util/AFIPdefinitions'
import {allDispatch as mapDispatchToProps, allState as mapStateToProps} from "../../Redux/Selectors"
import BaseAdminLite from "./BaseAdminLite";
import Base from "../UserPanel/Base";


function beforeUpload(file) {
    const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
    if (!isJpgOrPng) {
        message.error('Solo puedes subir imágenes en formato JPG/PNG!');
    }
    const isLt3M = file.size / 1024 / 1024 < 5;
    if (!isLt3M) {
        message.error('La imagen debe ser menor de 5MB!');
    }
    return isJpgOrPng && isLt3M;
}

const {Option} = Select;

class MiCuentaAdminLite extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            user: {},
            new_data: {},
            data: {
                oldPassword: null,
                newPassword: null,
                newPasswordRepeat: null,
            },
            loading: false,
            editting: false,
            visible: false,
            bajaMonotributo: false,
            loadingImage: false,
        };

    };


    onChange(image, idFoto) {
        this.setState({loadingImage: true})
        Storage.put(this.state.user.email.toLowerCase() + '/' + idFoto, image, {
            level: 'public',
            contentType: 'image/jpg'
        })
            .then(result => {
                message.success("Foto Cargada con Exito")
                let usr = {...this.state.user}
                usr[idFoto] = true
                this.setState({user: usr, loadingImage: false})
                this.call_api(true)

            })
            .catch(err => {
                console.log(err)
                this.setState({loadingImage: false})
            });

    }


    call_api = (foto) => {

        if (foto === true) {
            this.send_data()
        } else {
            this.props.form.validateFieldsAndScroll({first: true}, (err, values) => {
                if (!err) {
                    this.send_data()
                }
            })
        }
    }

    save = async () => {
        if(this.state.data.newPassword !== this.state.data.newPasswordRepeat) {
            message.error("Las contraseñas no coinciden");
            return;
        }
        if(!this.state.data.newPassword || this.state.data.newPassword.length < 8 ) {
            message.error("Las contraseña debe ser de al menos 8 caracteres");
            return;
        }
        if(this.state.data.newPassword.match(/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9]).*$/) == null){
            message.error("La contraseña debe contener letras mayusculas, minusculas y numeros");
            return;
        }

        try {
            this.setState({loading: true})
            const currentUser = await Auth.currentAuthenticatedUser();
            await Auth.changePassword(
                currentUser,
                this.state.data.oldPassword,
                this.state.data.newPassword
            );
            message.success("Contraseña actualizada con exito!")
        } catch (error) {
            if(error && error.code === 'LimitExceededException') {
                message.error("Error. Se ha excedido el numero de intentos. Vuelva a intentarlo en unos minutos");
            } else {
                message.error("Error. Verifique su contraseña actual");
            }
            console.error(error);
        } finally {
            this.setState({loading: false})
        }
    }


    componentDidMount() {

    }

    isEditing = () => {
        this.setState({editting: true})
    }

    updateData(field, value) {
        const data = {...this.state.data}
        data[field] = value
        this.setState({data})
    }

    cancell = () => {
        this.setState({editting: false});
        this.props.form.resetFields();
    }


    render() {
        if (this.state.loading) {
            return (
                <BaseAdminLite
                >
                    <Row></Row>
                    <Row type="flex" justify="space-around" align="middle" style={{marginTop: '150px'}}>
                        <Col style={{minHeight: '360px'}}>
                            <Spin indicator={CustomSpinner}/>
                        </Col>
                    </Row>
                    <Row></Row>
                </BaseAdminLite>)
        } else {


            const {getFieldDecorator} = this.props.form;

            return (

                <BaseAdminLite
                    selected="micuenta"
                >

                    <Card style={{marginBottom: "10px"}}
                          title={"Cambiar contraseña"}
                    >

                        <Row gutter={[8, 8]}>
                            <Col lg={6}>
                                <Form.Item label="Contraseña actual">{
                                    getFieldDecorator('oldPassword', {
                                        rules: [{
                                            required: true,
                                            message: 'requerido'
                                        },
                                        ],
                                        value: this.state.data.oldPassword,
                                        initialValue: this.state.data.oldPassword
                                    })(
                                        <Input.Password
                                            type={"password"}
                                            onChange={(e) => this.updateData("oldPassword", e.target.value ? e.target.value : null)}
                                        />
                                    )
                                }
                                </Form.Item>
                            </Col>

                            <Col lg={6}>
                                <Form.Item label="Nueva contraseña">{
                                    getFieldDecorator('newPassword', {
                                        rules: [{
                                            required: true,
                                            message: 'requerido'
                                        },
                                        ],
                                        value: this.state.data.newPassword,
                                        initialValue: this.state.data.newPassword
                                    })(
                                        <Input.Password
                                            type={"password"}
                                            onChange={(e) => this.updateData("newPassword", e.target.value ? e.target.value : null)}
                                        />
                                    )
                                }
                                </Form.Item>
                            </Col>

                            <Col lg={6}>
                                <Form.Item label="Repetir nueva contraseña">{
                                    getFieldDecorator('newPasswordRepeat', {
                                        rules: [{
                                            required: true,
                                            message: 'requerido'
                                        },
                                        ],
                                        value: this.state.data.newPasswordRepeat,
                                        initialValue: this.state.data.newPasswordRepeat
                                    })(
                                        <Input.Password
                                            type={"password"}
                                            onChange={(e) => this.updateData("newPasswordRepeat", e.target.value ? e.target.value : null)}
                                        />
                                    )
                                }
                                </Form.Item>
                            </Col>
                        </Row>
                    </Card>
                    <>
                        <Button
                            margin={"10px"}
                            onClick={this.save}
                        >Guardar
                        </Button>
                    </>

                </BaseAdminLite>
            )
        }
    }
}

const MyAccount = Form.create({name: 'my-account'})(MiCuentaAdminLite);
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(MyAccount));
